/**
 * @fileoverview gRPC-Web generated client stub for wisetime.user.timelinemessage.v4
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.14.0
// source: wisetime/user/timelinemessage/v4/user_timeline_message.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as wisetime_user_timelinemessage_v4_user_timeline_message_pb from '../../../../wisetime/user/timelinemessage/v4/user_timeline_message_pb';


export class UserTimelineMessageServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorListUserTimelineMessages = new grpcWeb.MethodDescriptor(
    '/wisetime.user.timelinemessage.v4.UserTimelineMessageService/ListUserTimelineMessages',
    grpcWeb.MethodType.UNARY,
    wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesRequest,
    wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesResponse,
    (request: wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesRequest) => {
      return request.serializeBinary();
    },
    wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesResponse.deserializeBinary
  );

  listUserTimelineMessages(
    request: wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesRequest,
    metadata: grpcWeb.Metadata | null): Promise<wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesResponse>;

  listUserTimelineMessages(
    request: wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesResponse) => void): grpcWeb.ClientReadableStream<wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesResponse>;

  listUserTimelineMessages(
    request: wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: wisetime_user_timelinemessage_v4_user_timeline_message_pb.ListUserTimelineMessagesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/wisetime.user.timelinemessage.v4.UserTimelineMessageService/ListUserTimelineMessages',
        request,
        metadata || {},
        this.methodDescriptorListUserTimelineMessages,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/wisetime.user.timelinemessage.v4.UserTimelineMessageService/ListUserTimelineMessages',
    request,
    metadata || {},
    this.methodDescriptorListUserTimelineMessages);
  }

}

